import _extends from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends";
import React from "react";
var __jsx = React.createElement;

/* eslint-disable complexity */
import { AtomicBlockType } from '@uno/common-cms';
import { Entities } from 'components/common/RichTextEditor/types';
import { getEntities } from 'components/common/RichTextEditor/util/entity';
import { AffiliationBlock } from '../AffiliationBlock';
import { AffiliationLink } from '../AffiliationLink';
import { Embed } from '../Embed';
import { ExternalLink } from '../ExternalLink';
import { Image } from '../Image';
import { InternalLink } from '../InternalLink';
import { Recipe } from '../Recipe';
import { SlideshowEmbed } from '../SlideshowEmbed';
import { Video } from '../Video';

var EntityEditingController = function EntityEditingController(_ref) {
  var editorRef = _ref.editorRef,
      editorState = _ref.editorState,
      removeBlock = _ref.removeBlock,
      removeEntity = _ref.removeEntity,
      updateBlockData = _ref.updateBlockData,
      updateEntity = _ref.updateEntity;
  var entities = getEntities(editorState);

  var getEntityEditProps = function getEntityEditProps(key, blockKey) {
    return {
      editorRef: editorRef,
      editorState: editorState,
      blockKey: blockKey,
      entityKey: key,
      removeBlock: removeBlock,
      removeEntity: removeEntity,
      updateBlockData: updateBlockData,
      updateEntity: updateEntity
    };
  };

  var EntityControllers = entities.map(function (_ref2) {
    var key = _ref2.key,
        type = _ref2.type,
        blockKey = _ref2.blockKey;
    var entityEditProps = getEntityEditProps(key, blockKey);

    switch (type) {
      case AtomicBlockType.AFFILIATION:
        return __jsx(AffiliationBlock, _extends({
          key: key
        }, entityEditProps));

      case AtomicBlockType.EMBED:
        return __jsx(Embed, _extends({
          key: key
        }, entityEditProps));

      case AtomicBlockType.IMAGE:
        return __jsx(Image, _extends({
          key: key
        }, entityEditProps));

      case AtomicBlockType.RECIPE:
        return __jsx(Recipe, _extends({
          key: key
        }, entityEditProps));

      case AtomicBlockType.SLIDESHOW_EMBED:
        return __jsx(SlideshowEmbed, _extends({
          key: key
        }, entityEditProps));

      case AtomicBlockType.VIDEO:
        return __jsx(Video, _extends({
          key: key
        }, entityEditProps));

      case Entities.AffiliationLink:
        return __jsx(AffiliationLink, _extends({
          key: key
        }, entityEditProps));

      case Entities.ExternalLink:
        return __jsx(ExternalLink, _extends({
          key: key
        }, entityEditProps));

      case Entities.InternalLink:
        return __jsx(InternalLink, _extends({
          key: key
        }, entityEditProps));

      default:
        return null;
    }
  });
  return __jsx(React.Fragment, null, EntityControllers);
};

export default EntityEditingController;